import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vouchersComponent from './vouchers.component';
import dataTable from 'angular-material-data-table';

let vouchersModule = angular.module('vouchers', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('vouchers', {
        url: '/vouchers',
        component: 'vouchers',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN', 'VOUCHERS', 'VOUCHERCOLLECTOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('vouchers', vouchersComponent)
.name;

export default vouchersModule;
